export type Difficulty = 'easy' | 'normal' | 'hard';

export interface DifficultyDefinition {
  decisionInterval: number;
  incomeMultiplier: number;
  buildChance: number;
  taskForceSize: number;
  tacticalAbilityChance: number;
}

export const aiDifficulty: Record<Difficulty, DifficultyDefinition> = {
  easy: {
    decisionInterval: 2.2,
    incomeMultiplier: 1,
    buildChance: 0.55,
    taskForceSize: 2,
    tacticalAbilityChance: 0.35,
  },
  normal: {
    decisionInterval: 1.2,
    incomeMultiplier: 1,
    buildChance: 1,
    taskForceSize: 4,
    tacticalAbilityChance: 0.7,
  },
  hard: {
    decisionInterval: 0.75,
    incomeMultiplier: 1.1,
    buildChance: 1,
    taskForceSize: 6,
    tacticalAbilityChance: 1,
  },
};
